import(/* webpackMode: "eager", webpackExports: ["AuthCard"] */ "/vercel/path0/frontend/components/auth-card.tsx");
